module.exports = __webpack_public_path__ + "img/wechat.446f3f75.svg";